import { render } from "./GestaoCheque.vue?vue&type=template&id=52234f03&scoped=true"
import script from "./GestaoCheque.vue?vue&type=script&lang=js"
export * from "./GestaoCheque.vue?vue&type=script&lang=js"

import "./GestaoCheque.vue?vue&type=style&index=0&id=52234f03&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52234f03"]])

export default __exports__